import { render } from "./Recursos.vue?vue&type=template&id=22d03488&scoped=true"
import script from "./Recursos.vue?vue&type=script&lang=js"
export * from "./Recursos.vue?vue&type=script&lang=js"

import "./Recursos.vue?vue&type=style&index=0&id=22d03488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d03488"]])

export default __exports__